<template>
	<easy-data-table
		class="data-table m-1 mt-0 me-1"
		table-class-name="customize-table"
		:headers="tableHeadersOrdered"
		:items="tableItemsAfterSearch"
		:loading="tableItems.length == 0"
		theme-color="rgb(198, 199, 200)"
		must-sort="true"
		:sort-by="sorting.sortBy"
		:sort-type="sorting.sortType" 
		:filter-options="filterOptions"
		:rows-items="[10,20,40,100]"
		:rows-per-page="easyDataTableRowsPerPage()"
		rows-per-page-message="записів на сторінці"
		rows-of-page-separator-message=" з "
		:table-min-height="380"
		:table-height="easyDataTableHeight()"
		:prevent-context-menu-row="false"
		@update-sort="updateSort"
		alternating
		buttons-pagination
	>
		<!-- If rows is empty -->
		<template #empty-message>
			Станцій не знайдено
		</template>

		<template #loading>
			<div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
				<span class="visually-hidden">Loading...</span>
			</div>
		</template>

		<template #header="header">
			{{ header.text }}
			<!-- {{ console.log('header', header) }} -->
			<!-- Column swap buttons -->
			<button
				v-if="isTableColumnsOrderEdit"
				type="button"
				class="btn btn-outline-secondary btn-sm order-btn m-0 mx-1 ms-2 p-0 px-1"
				@click="shiftColumnLeft(header.value)"
			>
				<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="" viewBox="0 0 16 16">
					<path fill-rule="evenodd" d="M12.5 15a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 1 0v13a.5.5 0 0 1-.5.5M10 8a.5.5 0 0 1-.5.5H3.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L3.707 7.5H9.5a.5.5 0 0 1 .5.5"/>
				</svg>
			</button>
			<button
				v-if="isTableColumnsOrderEdit"
				type="button"
				class="btn btn-sm btn-outline-secondary order-btn m-0 mx-1 p-0 px-1"
				@click="shiftColumnRight(header.value)"
			>
				<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="" viewBox="0 0 16 16">
					<path fill-rule="evenodd" d="M6 8a.5.5 0 0 0 .5.5h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L12.293 7.5H6.5A.5.5 0 0 0 6 8m-2.5 7a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 1 0v13a.5.5 0 0 1-.5.5"/>
				</svg>
			</button>
		</template>

		<!-- Filter to organization column -->
		<template #[orgNameHeaderSlotName]="header" v-if="!isTableColumnsOrderEdit">
			<!-- Don't create if criterias is empty because form will empty -->
			<table-filter-checkboxes
				v-if="organizationCriterias.length > 0"
				:criterias="organizationCriterias"
				:default-checked="sessionStore.getFilter($route.name, 'organization')"
				@checked-criterias="(criterias) => { saveFiters('organization', criterias) }"
			/>
			{{ header.text }}
		</template>

		<!-- Filter to department column -->
		<template #[depertmentHeaderSlotName]="header" v-if="!isTableColumnsOrderEdit">
			<!-- Don't create if criterias is empty because form will empty -->
			<table-filter-checkboxes
				v-if="departmentCriterias.length > 0"
				:criterias="departmentCriterias"
				:default-checked="sessionStore.getFilter($route.name, 'department')"
				@checked-criterias="(criterias) => { saveFiters('department', criterias) }"
			/>
			{{ header.text }}
		</template>

		<!-- Filter to sector column -->
		<template #[sectorHeaderSlotName]="header" v-if="!isTableColumnsOrderEdit">
			<!-- Don't create if criterias is empty because form will empty -->
			<table-filter-checkboxes
				v-if="sectorCriterias.length > 0"
				:criterias="sectorCriterias"
				:default-checked="sessionStore.getFilter($route.name, 'sector')"
				@checked-criterias="(criterias) => { saveFiters('sector', criterias) }"
			/>
			{{ header.text }}
		</template>

		<!-- Filter to activity column -->
		<template #[activityHeaderSlotName]="header" v-if="!isTableColumnsOrderEdit">
			<table-filter-checkboxes
				:criterias="Station.activityVariantsText"
				:default-checked="sessionStore.getFilter($route.name, 'activity')"
				@checked-criterias="(criterias) => { saveFiters('activity', criterias) }"
			/>
			<!-- :default-checked="['так']" -->
			{{ header.text }}
		</template>

		<!-- Filter to protection column -->
		<template #[protectionHeaderSlotName]="header" v-if="!isTableColumnsOrderEdit">
			<table-filter-checkboxes
				:criterias="Station.protectionVariantsText"
				:default-checked="sessionStore.getFilter($route.name, 'protection')"
				@checked-criterias="(criterias) => { saveFiters('protection', criterias) }"
			/>
			{{ header.text }}
		</template>

		<!-- Filter to mode column -->
		<template #[modeHeaderSlotName]="header" v-if="!isTableColumnsOrderEdit">
			<table-filter-checkboxes
				:criterias="Station.modeVariantsText"
				:default-checked="sessionStore.getFilter($route.name, 'mode')"
				@checked-criterias="(criterias) => { saveFiters('mode', criterias) }"
			/>
			{{ header.text }}
		</template>

		<!-- updateTime item customization -->
		<template #item-updateTime="{ updateTime }">
			{{ timeFromNowPromt(updateTime) }}
		</template>

		<!-- Name item customization -->
		<template #item-name="{ name, id }">
			<router-link
				class="text-start text-break text-reset text-decoration-none item-name-link"
				:to="{ name: 'station_control', params: { id: `${id}` } }"
			>
				{{ name }}
			</router-link>
		</template>

		<!-- Iout item customization -->
		<template #[iOutItemSlotName]="item">
			<span :class="{'text-decoration-line-through': !item.unitsConnection.powerUnit}">
				{{ item[PowerUnit.metricKeys.iOut] }}
			</span>
		</template>

		<!-- Uout item customization -->
		<template #[uOutItemSlotName]="item">
			<span :class="{'text-decoration-line-through': !item.unitsConnection.powerUnit}">
				{{ item[PowerUnit.metricKeys.uOut] }}
			</span>
		</template>

		<!-- Eout item customization -->
		<template #[eOutItemSlotName]="item">
			<span :class="{'text-decoration-line-through': !item.unitsConnection.powerUnit}">
				{{ item[PowerUnit.metricKeys.eOut] }}
			</span>
		</template>

		<!-- Emin item customization -->
		<template #[eMinItemSlotName]="item">
			<span :class="{'text-decoration-line-through': !item.unitsConnection.serviceUnit}">
				{{ item[ServiceUnit.metricKeys.eMin] }}
			</span>
		</template>

		<!-- Eavg item customization -->
		<template #[eAvgItemSlotName]="item">
			<span :class="{'text-decoration-line-through': !item.unitsConnection.serviceUnit}">
				{{ item[ServiceUnit.metricKeys.eAvg] }}
			</span>
		</template>

		<!-- Emax item customization -->
		<template #[eMaxItemSlotName]="item">
			<span :class="{'text-decoration-line-through': !item.unitsConnection.serviceUnit}">
				{{ item[ServiceUnit.metricKeys.eMax] }}
			</span>
		</template>

		<!-- U220 item customization -->
		<template #[u220ItemSlotName]="item">
			<span :class="{'text-decoration-line-through': !item.unitsConnection.serviceUnit}">
				{{ item[ServiceUnit.metricKeys.u220] }}
			</span>
		</template>

		<!-- Connection state customization -->
		<template #item-connectionState="{ unitsConnection, modemUnitLastConnectionDate, modemUnitConnectionQuality }">
			<!-- {{ connectionState }} -->
			<!-- Modem unit -->
			<unit-icon
				:unitType="unitsConnection.modemUnit == null ? 'blank' : 'modem'"
				:color="connectionColor(unitsConnection.modemUnit)"
			/>
			<!-- Power unit -->
			<unit-icon
				:unitType="unitsConnection.powerUnit == null ? 'blank' : 'power'"
				:color="connectionColor(unitsConnection.powerUnit)"
			/>
			<!-- Service unit -->
			<unit-icon
				:unitType="unitsConnection.serviceUnit == null ? 'blank' : 'service'"
				:color="connectionColor(unitsConnection.serviceUnit)"
			/>
			<!-- Electric meter unit -->
			<unit-icon
				:unitType="unitsConnection.powerMeterUnit == null ? 'blank' : 'power_meter'"
				:color="connectionColor(unitsConnection.powerMeterUnit)"
			/>
			<!-- No connection time counter or connection quality percent-->
			<span 
				v-if="unitsConnection.modemUnit !== null"
				class="ms-2"
				:class="{'conn-ok': unitsConnection.modemUnit, 'conn-err': !unitsConnection.modemUnit}"
			>
				{{ unitsConnection.modemUnit === true ?
					`${modemUnitConnectionQuality}%` :
					`${timeFromNowPromt(modemUnitLastConnectionDate)}`
				}}
			</span>
		</template>

		<!-- Boox door state customization -->
		<template #[boxDoorStateSlotName]="item">
			<span
				:class="{
					'conn-ok': item[ServiceUnit.metricKeys.fSecurityCircuitBoxDoor + 'state'] === ServiceUnit.boxDoorStateCodes.close,
					'conn-err': item[ServiceUnit.metricKeys.fSecurityCircuitBoxDoor + 'state'] === ServiceUnit.boxDoorStateCodes.open,
				}"
			>
				{{ decodeBoxDoorState(item) }}
			</span>
		</template>
	</easy-data-table>
</template>




<script>
import { inject } from 'vue'
import TableFilterCheckboxes from '@/components/TableFilterCheckboxes.vue'
import UnitIcon from '@/components/Icons/UnitIcon.vue'
import { useAccontStore } from '@/stores/AccountStore.js'
import { useStationsStore } from '@/stores/StationsStore.js'
import { useSessionStore } from '@/stores/SessionStore.js'
import { useEvents, eventSchema } from '@/composables/events.js'
import { Station } from '@/models/station.js'
import { PowerUnit } from '@/models/powerUnit.js'
import { ServiceUnit } from '@/models/serviceUnit.js'
import { ModemUnit } from '@/models/modemUnit.js'
// import { ElectricMeter } from '../../models/electricMeter.js'
import { CustomNavChecklist, EmptyNavSection } from '@/customNavSection'
import { EMPTY_COLUMN_VALUE, DEPARTMENT_TITLE, SECTOR_TITLE } from '@/app.conf'
import {
	timeFromNowPromt,
	timeFromNowS,
	verboseTimePeriod,
	fixNumberPrecision,
	connectionColor,
	easyDataTableHeight,
	easyDataTableRowsPerPage,
	compareArrays,
	subtractDaysFromNowDate,
	dayStart,
	dayEnd,
} from '@/helpers.js'

export default {
	MULT: 1000000000.0,

	components: {
		UnitIcon,
		TableFilterCheckboxes,
	},

	props: {
		nameFilter: {
			type: String,
			required: false,
			default: '',
		}
	},

	setup() {
		const accountStore = useAccontStore()
		const stationsStore = useStationsStore()
		const sessionStore = useSessionStore()
		const { allEvents, setFilters } = useEvents()
		const lightningsSearchDepthDays = 30
		setFilters({
			fromTime: dayStart(subtractDaysFromNowDate(lightningsSearchDepthDays)),
			toTime: dayEnd(new Date()),
			eventTypes: [eventSchema.eventType.allowed.lightning.key, ],
			// stationIds: null,
		})
		
		return {
			accountStore,
			stationsStore,
			sessionStore,

			lightningsSearchDepthDays,
			allEvents,

			Station,
			PowerUnit,
			ServiceUnit,
			timeFromNowPromt,
			connectionColor,
			easyDataTableHeight,
			easyDataTableRowsPerPage,
		}
	},

	data() {
		return {
			// Table
			isTableColumnsOrderEdit: false,
			// Filters
			filters: {
				organization: [],
				department: [],
				sector: [],
				activity: [],
				protection: [],
				mode: [],
			},
			// Columns for show in table
			columns: new CustomNavChecklist(),
		}
	},

	async mounted() {
		await this.initCustomNavbar()
	},

	methods: {
		async initCustomNavbar() {
			const psk = Station.passportKeys
			const puk = PowerUnit.metricKeys
			const suk = ServiceUnit.metricKeys
			const customColumns = ['protection',]
			if (this.accountStore.isPrimary) {
				customColumns.push(psk.orgName)
			}
			customColumns.push(psk.department, psk.sector,
				puk.iOut, puk.uOut, puk.eOut, suk.eMin, suk.eAvg, suk.eMax,
				puk.stationStabilizationMode,
				suk.fSecurityCircuitBoxDoor,
				'controlType',
				suk.u220,
				'updateTime',
				'lightnings',
				psk.isActive,
			)
			
			// Load custom nav from account if it present in storage
			//
			const columnsInStorage = Object.keys(this.accountStore.stationsColumns)
			const columnsActualy = [ ...this.columnNames.keys() ]
			// If columns array not exist or empty or not equal to target columns
			if (this.accountStore.stationsColumns == undefined
				|| this.accountStore.stationsColumns.constructor !== Object
				|| !compareArrays(columnsInStorage, columnsActualy)
			) {
				console.error('Station columns updated in settings because of missmatch.')

				let blankColumns = new Object();
				// Create columns settings
				[...this.columnNames.keys()].forEach((col, index) => {
					blankColumns[col] = {
						id: col,
						isShow: true,
						order: index,
					}
				})
				
				await this.accountStore.updateStationColumns(blankColumns)
			}

			// Create navbar lines from user settings
			customColumns.forEach((col) => {
				this.columns.addLine(
					col,
					this.colName(col),
					'Склад',
					this.accountStore.stationsColumns[col]?.isShow,
					(state) => {
						this.toggleColumnShow(col, state)
						this.saveSettings()
					},
				)
			})

			this.columns.addLine(
				'columns_order',
				'Порядок',
				'Порядок',
				this.isTableColumnsOrderEdit,
				() => {
					this.isTableColumnsOrderEdit = !this.isTableColumnsOrderEdit
				},
			)

			// Publicate new custom navigation section for nav component
			const navCustom = inject('customNavSection')
			if (navCustom) {
				navCustom.value = this.columns
			}
		},

		toggleColumnShow(colId, state) {
			//console.log(`toggle isShow ${colId} to ${state} `)
			
			const columns = this.accountStore.stationsColumns
			// if (columns[colId]) {
				columns[colId].isShow = state
			// } else {
			// 	columns[colId] = {
			// 		id: colId,
			// 		isShow: true,
			// 		order: undefined,
			// 	}
			// }
		},

		shiftColumnLeft(colId) {
			const columnsArray = Object.values(this.accountStore.stationsColumns)
			const sortedColumns = columnsArray.sort((a, b) => a.order - b.order)
			const curCol = sortedColumns[sortedColumns.findIndex((el) => el.id == colId)]

			// If column on the far left
			if (curCol.id == sortedColumns[0].id) {
				return
			}
			
			// Find left side visible culumn for current column
			let leftCol = null
			const leftColIndex = sortedColumns.findIndex((el) => el.id == curCol.id) - 1
			sortedColumns.forEach((col, index) => {
				if (index > leftColIndex) {
					return
				}

				if (col.isShow == true) {
					leftCol = col
				}
			})

			// Swap columns
			const tmp = this.accountStore.stationsColumns[curCol.id].order
			this.accountStore.stationsColumns[curCol.id].order = this.accountStore.stationsColumns[leftCol.id].order
			this.accountStore.stationsColumns[leftCol.id].order = tmp

			this.saveSettings()
		},

		shiftColumnRight(colId) {
			const columnsArray = Object.values(this.accountStore.stationsColumns)
			const sortedColumns = columnsArray.sort((a, b) => a.order - b.order)
			const curCol = sortedColumns[sortedColumns.findIndex((el) => el.id == colId)]
			
			// If column on the far right
			if (curCol.id == sortedColumns[sortedColumns.length - 1].id) {
				return
			}

			// Find right side visible culumn for current column
			let rightCol = null
			const rightColIndex = sortedColumns.findIndex((el) => el.id == curCol.id) + 1
			sortedColumns.forEach((col, index) => {
				if (index < rightColIndex) {
					return
				}

				if (col.isShow == true && rightCol == null) {
					rightCol = col
				}
			})

			// Swap columns
			const tmp = this.accountStore.stationsColumns[curCol.id].order
			this.accountStore.stationsColumns[curCol.id].order = this.accountStore.stationsColumns[rightCol.id].order
			this.accountStore.stationsColumns[rightCol.id].order = tmp

			this.saveSettings()
		},

		async updateSort(sortOptions) {
			this.accountStore.stationsSorting.sortBy = sortOptions.sortBy
			this.accountStore.stationsSorting.sortType = sortOptions.sortType

			await this.saveSettings()
		},

		async saveSettings() {
			await this.accountStore.save([this.accountStore.schema.settings.self,])
		},

		saveFiters(filterName, criterias) {
			this.filters[filterName] = criterias;
			const filters = this.sessionStore.getFilter(this.$route.name, filterName);
			filters.splice(0, filters.length);
			filters.push(...criterias);
		},

		// Column names
		colName (colId) {
			return this.columnNames.get(colId)
		},

		replaceEmptyColumnValue(value) {
			if (value === undefined || String(value) === EMPTY_COLUMN_VALUE) {
				return "-"
			} else {
				return value
			}
		},

		decodeBoxDoorState(encodedState) {
			const stateCode = encodedState[ServiceUnit.metricKeys.fSecurityCircuitBoxDoor+'state']
			const period = encodedState[ServiceUnit.metricKeys.fSecurityCircuitBoxDoor+'time']
			return `${!stateCode ? '' : ServiceUnit.boxDoorStatePromt(stateCode)} 
				${period === undefined || !period ? '' : verboseTimePeriod(period)}`
		}
	},

	computed: {
		allStations() {
			return this.stationsStore.stationsArray
		},

		columnNames() {
			return new Map([
				[Station.passportKeys.name,'Назва'],
				["protection", "Захист"],
				[Station.passportKeys.orgName,'Організація'],
				[Station.passportKeys.department, 
					this.accountStore.organization[this.accountStore.schema.organization.departmentTitle] ?
					this.accountStore.organization[this.accountStore.schema.organization.departmentTitle] :
					DEPARTMENT_TITLE],
				[Station.passportKeys.sector,
					this.accountStore.organization[this.accountStore.schema.organization.sectorTitle] ?
					this.accountStore.organization[this.accountStore.schema.organization.sectorTitle] :
					SECTOR_TITLE],
				[PowerUnit.metricKeys.iOut,'A'],
				[PowerUnit.metricKeys.uOut,'V'],
				[PowerUnit.metricKeys.eOut,'E'],
				[ServiceUnit.metricKeys.eMin,'Emin'],
				[ServiceUnit.metricKeys.eAvg,'Eavg'],
				[ServiceUnit.metricKeys.eMax,'Emax'],
				[ServiceUnit.metricKeys.u220,'Напруга'],
				[PowerUnit.metricKeys.stationStabilizationMode, 'Тип стаб.'],
				[ServiceUnit.metricKeys.fSecurityCircuitBoxDoor, ServiceUnit.securityCircuitPurposeNames.box_door],
				['controlType', 'Реж. упр.'],
				['connectionState', 'Стан зв\'язку'],
				['updateTime', 'Опитування'],
				['lightnings', 'Блискавки'],
				[Station.passportKeys.isActive, 'Активна'],
			])
		},

		tableHeaders() {
			const header = []

			// Create all columns
			header.push({
				text: this.colName(Station.passportKeys.name),
				value: Station.passportKeys.name,
				sortable: !this.isTableColumnsOrderEdit,
				width: 320,
			})
			header.push({
				text: this.colName('protection'),
				value: 'protection',
				sortable: !this.isTableColumnsOrderEdit,
			})
			if (this.accountStore.isPrimary) {
				header.push({
					text: this.colName(Station.passportKeys.orgName),
					value: Station.passportKeys.orgName,
					sortable: !this.isTableColumnsOrderEdit,
					width: 300,
				})
			}
			header.push({
				text: this.colName(Station.passportKeys.department),
				value: Station.passportKeys.department,
				sortable: !this.isTableColumnsOrderEdit,
				width: 300,
			})
			header.push({
				text: this.colName(Station.passportKeys.sector),
				value: Station.passportKeys.sector,
				sortable: !this.isTableColumnsOrderEdit,
				width: 300,
			})
			header.push({ text: this.colName(PowerUnit.metricKeys.iOut), value: PowerUnit.metricKeys.iOut })
			header.push({ text: this.colName(PowerUnit.metricKeys.uOut), value: PowerUnit.metricKeys.uOut })
			header.push({ text: this.colName(PowerUnit.metricKeys.eOut), value: PowerUnit.metricKeys.eOut })
			header.push({ text: this.colName(ServiceUnit.metricKeys.eMin), value: ServiceUnit.metricKeys.eMin })
			header.push({ text: this.colName(ServiceUnit.metricKeys.eAvg), value: ServiceUnit.metricKeys.eAvg })
			header.push({ text: this.colName(ServiceUnit.metricKeys.eMax), value: ServiceUnit.metricKeys.eMax })
			header.push({
				text: this.colName(ServiceUnit.metricKeys.u220),
				value: ServiceUnit.metricKeys.u220,
				sortable: !this.isTableColumnsOrderEdit,
			})
			header.push({
				text: this.colName(PowerUnit.metricKeys.stationStabilizationMode),
				value: PowerUnit.metricKeys.stationStabilizationMode,
				sortable: !this.isTableColumnsOrderEdit,
			})
			header.push({
				text: this.colName('controlType'),
				value: 'controlType',
				sortable: !this.isTableColumnsOrderEdit,
			})
			header.push({
				text: this.colName("connectionState"),
				value: "connectionState",
				sortable: !this.isTableColumnsOrderEdit,
				width: 200,
			})
			header.push({ text: this.colName('updateTime'), value: 'updateTime' })
			header.push({ text: this.colName('lightnings'), value: 'lightnings' })
			header.push({ text: this.colName(Station.passportKeys.isActive), value: Station.passportKeys.isActive })
			header.push({
				text: this.colName(ServiceUnit.metricKeys.fSecurityCircuitBoxDoor),
				value: ServiceUnit.metricKeys.fSecurityCircuitBoxDoor,
				sortable: !this.isTableColumnsOrderEdit,
			})

			return header
		},

		tableHeadersFiltered() {
			if (this.accountStore.stationsColumns == undefined
				|| (this.accountStore.stationsColumns.constructor === Object
				&& Object.keys(this.accountStore.stationsColumns).length === 0)
			) {
				return this.tableHeaders
			}

			const header = [...this.tableHeaders]
			// Remove hidden columns			
			// console.log('Station columns setting = ', this.accountStore.stationsColumns)
			//console.log('Header before filtering', this.tableHeaders)
			for (const value of Object.values(this.accountStore.stationsColumns)) {
				if (value.isShow === false) {
					// console.log(`Column ${value.id} isShow = ${value.isShow}`)
					
					const columnHeaderIndex = header.findIndex((el) => el.value == value.id)
					if (columnHeaderIndex !== -1) {
						header.splice(columnHeaderIndex, 1)
					}
				}
			}
			// console.log('Header after filtering', header)

			return header
		},

		tableHeadersOrdered() {
			if (this.accountStore.stationsColumns == undefined
				|| (this.accountStore.stationsColumns.constructor === Object
				&& Object.keys(this.accountStore.stationsColumns).length === 0)
			) {
				return this.tableHeadersFiltered
			}

			const header = []
			const columnsArray = Object.values(this.accountStore.stationsColumns)
			const sortedColumns = columnsArray.sort((a, b) => a.order - b.order)

			sortedColumns.forEach((col) => {
				const indexInFiltered = this.tableHeadersFiltered.findIndex((el) => el.value == col.id)
				
				if (indexInFiltered !== -1) {
					header.push(this.tableHeadersFiltered[indexInFiltered])
				}
			})

			return header
		},

		tableItems() {
			// console.log(`Station ${this.stationsStore.stationsArray[2].name}: `, this.stationsStore.stationsArray[2], this.stationsStore.stationsArray[2]?.modem_unit.isConnect)
			const rows = []
// console.log(`Station ${this.stationsStore.stationsArray[0]?.name}`, this.stationsStore.stationsArray[0])
			// Iterate over stations, make station row
			this.allStations.forEach(station => {
				//console.log("Station", station.name, station)
				let row = new Object()

				// Units connection
				const connection = {
					powerUnit: 
						station.passport.get(Station.passportKeys.powerUnit.self)[Station.passportKeys.powerUnit.unitVersion] == PowerUnit.versions.unknown ?
						null :
						station.power_unit.isConnect,
					serviceUnit: 
						station.passport.get(Station.passportKeys.serviceUnit.self)[Station.passportKeys.serviceUnit.unitVersion] == ServiceUnit.versions.unknown ?
						null :
						station.service_unit.isConnect,
					modemUnit:
						station.passport.get(Station.passportKeys.modemUnit.self)[Station.passportKeys.modemUnit.unitVersion] == ModemUnit.versions.unknown ?
						null :
						station.modem_unit.isConnect,
					powerMeterUnit:
						station?.electricMeterIsSeparateUnit ?
						station.electricMeter.isConnect :
						null,
				}

				row[Station.passportKeys.name] = station.shortName ? station.shortName : station.name
				row[Station.passportKeys.orgName] = station.passport.get(Station.passportKeys.orgName)
				row[Station.passportKeys.department] = this.replaceEmptyColumnValue(station.passport.get(Station.passportKeys.department)?.title)
				row[Station.passportKeys.sector] = this.replaceEmptyColumnValue(station.passport.get(Station.passportKeys.sector)?.title)
				row[PowerUnit.metricKeys.iOut] = station.power_unit.getMetricValue(PowerUnit.metricKeys.iOut, 2)
				row[PowerUnit.metricKeys.uOut] = station.power_unit.getMetricValue(PowerUnit.metricKeys.uOut, 2)

				// If no potential source is define
				if (station.uProtectSource == null || station.uProtectSource == undefined) {
					row[PowerUnit.metricKeys.eOut] = '-'
					row[ServiceUnit.metricKeys.eMin] = '-'
					row[ServiceUnit.metricKeys.eMax] = '-'
					row[ServiceUnit.metricKeys.eAvg] = '-'
				} else {
					row[PowerUnit.metricKeys.eOut] =station.power_unit.getMetricValue(PowerUnit.metricKeys.eOut, 2)
					row[ServiceUnit.metricKeys.eMin] = station.getFormatedMetric(ServiceUnit.metricKeys.eMin, 'service', 2)
					row[ServiceUnit.metricKeys.eMax] = station.getFormatedMetric(ServiceUnit.metricKeys.eMax, 'service', 2)
					row[ServiceUnit.metricKeys.eAvg] = station.getFormatedMetric(ServiceUnit.metricKeys.eAvg, 'service', 2)
				}
				
				row[ServiceUnit.metricKeys.u220] = station.getFormatedMetric(ServiceUnit.metricKeys.u220, 'service', 2)
				row[PowerUnit.metricKeys.stationStabilizationMode] = station.power_unit.stabilizationModeText
				
				const boxDoorState = station.getFormatedMetric(
					ServiceUnit.metricKeys.fSecurityCircuitBoxDoor,
					'service'
				)
				row[ServiceUnit.metricKeys.fSecurityCircuitBoxDoor] = boxDoorState == '' ? '' : Number(boxDoorState) * this.$options.MULT
				row[ServiceUnit.metricKeys.fSecurityCircuitBoxDoor+'state'] = boxDoorState
				if (boxDoorState == ServiceUnit.boxDoorStateCodes.open) {
					const period = timeFromNowS(station.specificMetrics.boxDoorLastCloseTime)
					row[ServiceUnit.metricKeys.fSecurityCircuitBoxDoor] += period ? period : 0
					row[ServiceUnit.metricKeys.fSecurityCircuitBoxDoor+'time'] = period
				} else if (boxDoorState == ServiceUnit.boxDoorStateCodes.close) {
					const period = timeFromNowS(station.specificMetrics.boxDoorLastOpenTime)
					row[ServiceUnit.metricKeys.fSecurityCircuitBoxDoor] += period ? period : 0
					row[ServiceUnit.metricKeys.fSecurityCircuitBoxDoor+'time'] = period
				}
				
				row['id'] = station.id
				row['updateTime'] = station.updateTime

				if (station.passport.has(Station.passportKeys.location)) {
					const lastLightning = this.eventsByStationMap.get(station.id)?.at(-1)
					if (lastLightning) {
						const time = timeFromNowPromt(lastLightning[eventSchema.payload.key][eventSchema.payload.allowed.flashTimeUTC.key])
						const isAboveStaion = lastLightning[eventSchema.payload.key][eventSchema.payload.allowed.distanceKm.key] 
							<= lastLightning[eventSchema.payload.key][eventSchema.payload.allowed.footprintRadiusKm.key]
						const flashDistance = isAboveStaion
							? lastLightning[eventSchema.payload.key][eventSchema.payload.allowed.distanceKm.key]
							: lastLightning[eventSchema.payload.key][eventSchema.payload.allowed.distanceKm.key]
								+ lastLightning[eventSchema.payload.key][eventSchema.payload.allowed.footprintRadiusKm.key]
						
						row['lightnings'] = `${time}, ${isAboveStaion ? 'над станцією' : `${flashDistance.toFixed(1)} км`}`
					} else {
						row['lightnings'] = `не виявлено за ${this.lightningsSearchDepthDays} днів`
					}					
				} else {
					row['lightnings'] = 'вкажіть координати'
				}
				
				row['protection'] = station.protectionText
				row['controlType'] = station.controlTypeText
				row['unitsConnection'] = connection

				const modemUnitLastConnectionDate = station.getFormatedMetric(ModemUnit.metricKeys.lastConnection, 'modem')
				const conState = (connection, weight) => {
					switch(connection) {
						case true:
							return weight * this.$options.MULT
						case false:
							return 0
						case null:
							return 100
						default:
							return 0
					}
				}
				row["connectionState"] = conState(connection.modemUnit, 128)
					+ conState(connection.powerUnit, 64)
					+ conState(connection.serviceUnit, 32)
					+ conState(connection.powerMeterUnit, 16)
				if (connection.modemUnit === true) {
					row["connectionState"] += fixNumberPrecision(station.modem_unit.connectionQuality, 0)
				} else {
					if (timeFromNowS(modemUnitLastConnectionDate)) {
						row["connectionState"] += Number(timeFromNowS(modemUnitLastConnectionDate))
						row["connectionState"] *= -1
					} else {
						// for sort stations without connection information
						row["connectionState"] -= this.$options.MULT * 2
					}
				}

				row["modemUnitLastConnectionDate"] = modemUnitLastConnectionDate
				row["modemUnitConnectionQuality"] = fixNumberPrecision(station.modem_unit.connectionQuality, 0)
				row[Station.passportKeys.isActive] = station.isActive ? "так" : "ні"
				
				// Extra filter by default (show only active) if column is not showing.
				// If column is showing
				if (this.accountStore.stationsColumns[Station.passportKeys.isActive]?.isShow) {
					// Add row to table
					rows.push(row)
				// If column is not showing
				} else {
					// If station is active, then show row. Otherwise - hide.
					if (station.isActive) {
						rows.push(row)
					}
				}
			})

			return rows
		},

		tableItemsAfterSearch() {
			const rows = this.tableItems
			const search = this.nameFilter.trim()

			// If search phrase is empty
			if (search === '') {
				return rows
			// If search phrase is one word
			} else if (search.indexOf(' ') == -1) {
				// Filter items where any word starts with search phrase
				return rows.filter((el) => {
					// Split string to words
					const words = el[Station.passportKeys.name].toLowerCase().split(/\s+/)
					// Check awery word
					return words.some((word) => 
						word.startsWith(search.toLowerCase())
					)
				})
			} else {
				return rows.filter((el) => el[Station.passportKeys.name].toLowerCase().includes(search.toLowerCase()))
			}
		},

		organizationCriterias() {
			return this.organizationNames.map((name) => name)
		},

		departmentCriterias() {
			return this.departmentNames.map((name) => name)
		},

		sectorCriterias() {
			return this.sectorNames.map((name) => name)
		},

		sorting() {
			return this.accountStore.stationsSorting
		},

		organizationNames() {
			let names = []

			this.stationsStore.stationsArray.forEach(station => {
				const name = station.passport.get(Station.passportKeys.orgName)
				if (!names.includes(name)) {
					names.push(name)
				}
			})

			return names
		},

		departmentNames() {
			let names = []

			this.stationsStore.stationsArray.forEach(station => {
				const department = station.passport.get(Station.passportKeys.department)
				let name = department === undefined ? "-" : department.title

				if (!names.includes(name)) {
					names.push(name)
				}
			})

			return names
		},

		sectorNames() {
			let names = []

			this.stationsStore.stationsArray.forEach(station => {
				const sector = station.passport.get(Station.passportKeys.sector)
				let name = sector === undefined ? "-" : sector.title
				
				if (!names.includes(name)) {
					names.push(name)
				}
			})
			// console.log('sectorNames', names)
			return names
		},

		filterOptions() {
			const filterOptionsArray = new Array()
			const filteredHeaderFields = this.tableHeadersFiltered.map((el) => el.value)
			
			// Add filter only if column is shown
			if (filteredHeaderFields.includes(Station.passportKeys.orgName)) {
				filterOptionsArray.push({
					field: Station.passportKeys.orgName,
					comparison: 'in',
					criteria: this.filters.organization,
				})
			}

			// Add filter only if column is shown
			if (filteredHeaderFields.includes(Station.passportKeys.department)) {
				filterOptionsArray.push({
					field: Station.passportKeys.department,
					comparison: 'in',
					criteria: this.filters.department,
				})
			}

			// Add filter only if column is shown
			if (filteredHeaderFields.includes(Station.passportKeys.sector)) {
				filterOptionsArray.push({
					field: Station.passportKeys.sector,
					comparison: 'in',
					criteria: this.filters.sector,
				})
			}

			// Add filter only if column is shown
			if (filteredHeaderFields.includes(Station.passportKeys.isActive)) {
				filterOptionsArray.push({
					field: Station.passportKeys.isActive,
					comparison: 'in',
					criteria: this.filters.activity,
				})
			}

			// Add filter only if column is shown
			if (filteredHeaderFields.includes('protection')) {
				filterOptionsArray.push({
					field: 'protection',
					comparison: 'in',
					criteria: this.filters.protection,
				})
			}

			// Add filter only if column is shown
			if (filteredHeaderFields.includes(PowerUnit.metricKeys.stationStabilizationMode)) {
				filterOptionsArray.push({
					field: PowerUnit.metricKeys.stationStabilizationMode,
					comparison: 'in',
					criteria: this.filters.mode,
				})
			}

			return filterOptionsArray;
		},

		eventsByStationMap() {
			const map = new Map()

			// Make map[stationId:[events]]
			for (const event of this.allEvents) {
				const stationId = event[eventSchema.stationId.key]
				let eventsArray = map.get(stationId)
				if (eventsArray === undefined) {
					map.set(stationId, new Array())
					eventsArray = map.get(stationId)
				}

				eventsArray.push(event)
			}

			// Sort events by flash time
			map.forEach((value) => 
				value.sort((a, b) => 
					a[eventSchema.payload.key][eventSchema.payload.allowed.flashTimeUTC.key].getTime()
						- b[eventSchema.payload.key][eventSchema.payload.allowed.flashTimeUTC.key].getTime()
				)
			)
			
			return map
		},

		orgNameHeaderSlotName() { return "header-" + Station.passportKeys.orgName },
		depertmentHeaderSlotName() { return "header-" + Station.passportKeys.department },
		sectorHeaderSlotName() { return "header-" + Station.passportKeys.sector },
		activityHeaderSlotName() { return "header-" + Station.passportKeys.isActive },
		protectionHeaderSlotName() { return "header-" + 'protection' },
		modeHeaderSlotName() { return "header-" + PowerUnit.metricKeys.stationStabilizationMode },
		iOutItemSlotName() { return 'item-' + PowerUnit.metricKeys.iOut },
		uOutItemSlotName() { return 'item-' + PowerUnit.metricKeys.uOut },
		eOutItemSlotName() { return 'item-' + PowerUnit.metricKeys.eOut },
		eMinItemSlotName() { return 'item-' + ServiceUnit.metricKeys.eMin },
		eAvgItemSlotName() { return 'item-' + ServiceUnit.metricKeys.eAvg },
		eMaxItemSlotName() { return 'item-' + ServiceUnit.metricKeys.eMax },
		u220ItemSlotName() { return 'item-' + ServiceUnit.metricKeys.u220 },
		boxDoorStateSlotName() { return 'item-' + ServiceUnit.metricKeys.fSecurityCircuitBoxDoor },
	},

	beforeUnmount() {
		// Clear custom nav section
		let navCustom = inject('customNavSection')
		navCustom.value = new EmptyNavSection()
	},
}
</script>




<style src="@/assets/table.css" scoped />
<style src="@/assets/widget.css" scoped />
<style scoped>
	.order-btn:hover svg path{
		fill: #0a58ca
	}

	.item-name-link {
		display: block;
		width: 100%;
		height: 100%;
	}
</style>
